import React, { Component } from 'react';
import './WeightBenefits.css';
import _ from 'lodash';
import WeightBenefitsTabs from './WeightBenefitsTabs/WeightBenefitsTabs';
import CreateWeightlModal from './CreateWeightlModal/CreateWeightlModal';
import { ContentLowPriority } from 'material-ui/svg-icons';
import { debug } from 'util';
import AbilityToCompeteError from './AbilityToCompeteError/AbilityToCompeteError';

class WeightBenefits extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goNextStep: false,
            tabs: [],
            competeData: [],
            createWeightModal: false,
            benefitsData: [],
            createNewTabPending: false,
            createNewTabDataPending: [],
            deleteItemProsccess: false,
        }
    }

    createWeight = () => {
        this.setState({
            createWeightModal: true
        })
    }

    createWeightClose = () => {
        this.setState({
            createWeightModal: false
        })
    }

    createWeightTab = (data) => {
        let tabs = this.state.tabs;
        tabs.push({
            groupId: data.groupId,
            groupName: data.groupName,
            segmentId: data.segmentId,
            segmentName: data.segmentName,
        });

        this.setState({
            createNewTabPending : true,
            tabs,
            newItem: {
                segmentId: data.segmentId,
                groupId: data.groupId,
            }
        });

        let body = {
            projectId: this.props.projectId,
            type : 'benefitsLadder',
            groupId: data.groupId,
        }
        let challengeData = {
            type : "challenge",
            projectId : this.props.projectId,
        }
        this.props.getBenefits(body);
        this.createWeightClose();
        this.props.getChallengeStatements(challengeData);
    }

    componentWillMount() {
        let customerSegmentData ={
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData ={
            projectId: this.props.projectId,
            type: 'compete'
        }
        let challengeData = {
            type : "challenge",
            projectId : this.props.projectId,
        }

        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getChallengeStatements(challengeData);
        this.props.getSegmentation(customerSegmentData);
        //segmentation={this.props.segmentation}
        //this.props.getBenefits(benefitData);

    }

    onNextButtonClick = () => {
        let stepValidation;
        let dataArr = 0;
        let newCompeteData = [];
        this.state.tabs.map(tab=>{
            this.state.competeData.map(item=>{
                if(tab.groupId===item.groupId && tab.segmentId ===  item.segmentId){
                    newCompeteData.push(item)
                }
            });
        })
        this.state.competeData = newCompeteData
        this.state.competeData.map(item=>{
            dataArr = dataArr + +item.wt
        });
        let k = this.state.tabs.length
        // let findZero = this.state.competeData.find(r => r.wt === 0 || r.wt === '0');
        let findZero = false;
        if( !findZero && (dataArr === 100 * k ) ){
            stepValidation = true;
        } else {
            stepValidation = false;
        }
        if(stepValidation){
            if( this.state.createdData ) {
                let body = {
                    projectId: this.props.projectId,
                    type: "compete",
                    dataBenefits: this.state.competeData
                }
                this.setState({ goNextStep : true });
                this.props.createAbilityOfCompete(body)
            }
            if( this.state.editedData ) {
                let body = {
                    id: this.props.compete.competeData.Items[0].id,
                    projectId: this.props.projectId,
                    type: "compete",
                    dataBenefits: this.state.competeData
                }

                this.setState({ goNextStep : true })
                this.props.editAbilityOfCompete(body);
            }
        }else {
            this.abilityToCompeteErrorModal('');
        }
    }

    abilityToCompeteErrorModal = (abilityToCompeteErrorMessage) => {
        this.setState({  abilityToCompeteError : !this.state.abilityToCompeteError, abilityToCompeteErrorMessage: abilityToCompeteErrorMessage })
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData)) {
            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {

                // console.log(nextProps.compete.customerSegmentData)
                //debugger
                let tabs = [ ...this.state.tabs];
                let oldGroupId = null;
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);
                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);
                    if(segmentData && !this.state.deleteItemProsccess){
                        tabs.push({
                            groupId: item.groupId,
                            groupName: customerSegmentItem.groupName,
                            segmentId: item.segmentId,
                            segmentName: segmentData.name
                        });
                    }


                    if(_.isEmpty(nextProps.compete.benefitsData) && (item.groupId !== oldGroupId)){
                        oldGroupId = item.groupId
                        let benefitData = {
                            projectId: this.props.projectId,
                            type : 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        this.props.getBenefits(benefitData)
                    }
                });

                this.setState({
                    competeData: nextProps.compete.competeData.Items[0].dataBenefits,
                    editedData: true,
                    createdData : false,
                    tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
                });
            }

            if( _.isEmpty(nextProps.compete.competeData.Items) && !this.state.createdData){

                this.setState({createdData : true, editedData: false })
            }
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) &&  _.isEmpty(this.state.benefitsData)){
            nextProps.compete.benefitsData.res.map(item=>{

                this.state.benefitsData.push({
                    benefitId: item.id,
                    groupId: nextProps.compete.benefitsData.body.groupId,
                    projectId: nextProps.compete.benefitsData.body.projectId,
                    benefitName: item.name,
                })
            })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) && this.state.createNewTabPending && nextProps.compete.benefitsFetched){
            let competeData = this.state.competeData;
            for (let benefitsItem of nextProps.compete.benefitsData.res) {
                competeData.push({
                    segmentId: this.state.newItem.segmentId,
                    groupId: this.state.newItem.groupId,
                    benefitId: benefitsItem.id,
                    wt: 0
                })
            }
            this.setState({ createNewTabPending : false, competeData });
        }

        if(!nextProps.compete.createAbilityOfCompeteFetching  && nextProps.compete.createAbilityOfCompeteData && nextProps.compete.createAbilityOfCompeteData.statusCode === 200 && this.props.groupStepState === 1 && this.state.goNextStep) {
            this.props.groupStateNext();
        }

        if( this.state.deleteItemProsccess &&  !nextProps.compete.createAbilityOfCompeteFetching &&nextProps.compete.createAbilityOfCompeteData && nextProps.compete.createAbilityOfCompeteData.statusCode === 200){

            this.setState({ deleteItemProsccess : false, competeData : [] })
            let competeData ={
                projectId: this.props.projectId,
                type: 'compete'
            }
            this.props.getCompete(competeData);
        }

    }

    onDeleteTab = (data) => {
        let deletedItemGroupId = data.groupId;
        let deletedItemSegmentId = data.segmentId;
        let updatedData = [];
        let updatedTab = [];
        for (let item of this.state.competeData){
            (item.groupId !== deletedItemGroupId || item.segmentId !== deletedItemSegmentId ) &&
            updatedData.push(item) ;
        }
        for (let item of this.state.tabs){
            (item.groupId !== deletedItemGroupId || item.segmentId !== deletedItemSegmentId ) && updatedTab.push(item) ;
        }
        this.setState({
            competeData: updatedData,
            tabs: updatedTab,
            deleteItemProsccess: true,
        }, () => this.deleteRequest())
    }

    deleteRequest = () => {
        if(!_.isEmpty(this.props.compete.competeData.Items)){
            let body = {
                id: this.props.compete.competeData.Items[0].id,
                projectId: this.props.projectId,
                type: "compete",
                dataBenefits: this.state.competeData
            }
            this.props.editAbilityOfCompete(body);
        }else{
            this.setState({deleteItemProsccess: false})
        }
    }

    onChangeWT = (e, data) => {
        let value = e.target.value;

        let changedItem  =  this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId  && r.segmentId === data.segmentId);

        changedItem.wt = value
        this.setState({ weighting: this.state.weighting }
            // , () => this.weightingNumber()
        )
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                  <div className="row">
                    <div className="col-sm-12">
                      <h5>ABILITY TO COMPETE</h5>
                    </div>
                  </div>
                  { (!this.props.compete.competeFetching &&  (!this.props.compete.createAbilityOfCompeteFetching && !this.state.deleteItemProsccess)) &&

                      <div className='row'>
                          <div className="col-md-12">
                              <div className='card'>
                                <div className="card-header">
                                  <div className="col-md-12">
                                    <div className="criteria-title-box">
                                        <h5>Weigh Benefits Sought</h5>
                                        <span>Distribute 100 weighting points to illustrate the relative importance of each benefit to the customer</span>
                                    </div>
                                  </div>
                                </div>
                                <div className='card-body'>
                                    { !this.state.createNewTabPending && this.props.benefits.benefitsLadderData.Items && this.props.benefits.benefitsLadderData.Items[0].data.length>0 &&  !this.props.compete.competeFetching &&
                                        <WeightBenefitsTabs
                                            tabs={this.state.tabs}
                                            challengeStatementData={this.props.challengeStatement.getChallengeStatementData}
                                            benefitsData={this.state.benefitsData}
                                            createWeight={this.createWeight}
                                            competeData={this.state.competeData}
                                            onChangeWT={this.onChangeWT}
                                            onDeleteTab={this.onDeleteTab}
                                            benefits={this.props.benefits}
                                            tabStep={this.props.tabStep}
                                            onTabChange={this.props.onTabChange}
                                            compete={this.props.compete}
                                            segmentation={this.props.segmentation}
                                        />
                                    }
                                </div>
                              </div>
                          </div>
                          <div className='col-sm-12'>
                              <div className='card'>
                                  <div className='card-body'>
                                      <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                      {/* <a href="/toolkit" className='btn empty-btn default'>Back</a> */}
                                      <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  }

                  { (this.props.compete.competeFetching || (this.props.compete.createAbilityOfCompeteFetching && this.state.deleteItemProsccess)) &&
                      <div className='col-sm-12'>
                          <div className='card'>
                              <div className="card-body">
                                  {this.elementInfiniteLoad()}
                              </div>
                          </div>
                      </div>
                  }
                  {this.state.createWeightModal &&
                      <CreateWeightlModal
                          projectId={this.props.projectId}
                          compete={this.props.compete}
                          createWeightClose={this.createWeightClose}
                          createWeightTab={this.createWeightTab}
                      />
                  }
                  { this.state.abilityToCompeteError &&
                      <AbilityToCompeteError
                          groupSegment={this.state.abilityToCompeteErrorMessage}
                          abilityToCompeteErrorModal={this.abilityToCompeteErrorModal}
                      />
                  }
                </div>
            </div>
        )
    }
}
export default (WeightBenefits);



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/WeightBenefits/WeightBenefits.jsx